import IdentificationError from './IdentificationError';
class IdentificationNumberIsInvalid extends IdentificationError {
    constructor(options) {
        super('Identification number is invalid', options);
    }
}
export default IdentificationNumberIsInvalid;
